export const urlHelper = {
  methods: {
    urlParam: function (paramName) {
      var results = new RegExp("[\?&]" + paramName + "=([^&#]*)").exec(window.location.href)
      if (results == null) {
        return null
      } else {
        return decodeURIComponent(results[1]) || 0
      }
    }
  }
}
